import React, { useState, useEffect } from 'react';
import FsLightbox from 'fslightbox-react';

interface IProps {
    images: Array<string>;
    path: string;
    selectedImageIndex: number;
}

export const Gallery: React.FC<IProps> = ({ images, selectedImageIndex }) => {
    const [toggler, setToggler] = useState(false);

    useEffect(() => {
        if (selectedImageIndex) {
            setToggler((prev) => !prev);
        }
    }, [selectedImageIndex]);

    return (
        <FsLightbox
            toggler={toggler}
            sources={images}
            slide={selectedImageIndex}
            type="image"
            disableLocalStorage={true}
        />
    );
};
